const createModelGraphNodeMap = modelGraph =>
  modelGraph?.model_graph?.nodes?.reduce(
    (acc, node) => ({
      ...acc,
      [node.id]: node,
    }),
    {}
  );

const createModelDriverNodeMap = modelDriver =>
  modelDriver?.variable_list?.reduce(
    (acc, variable) => ({
      ...acc,
      [variable.column_name || variable.id]: variable,
    }),
    {}
  );

export { createModelGraphNodeMap, createModelDriverNodeMap };
